// Mapa Sanktuarium

import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Kratka } from '../components/Kratka';
import { /*LayoutAnimation, UIManager,*/ Platform, StyleSheet, PixelRatio, View, Text, Image, ImageBackground, Dimensions, TouchableOpacity, useWindowDimensions } from "react-native";
import { Audio, Video } from 'expo-av';
import { Animated as RNAnimated } from 'react-native';
import Svg, { Defs, ClipPath, Rect, Path, G, Symbol } from 'react-native-svg';
//import { useHover, useFocus, useActive } from 'react-native-web-hooks';
import { useMemoOne } from 'use-memo-one';
import Animated, {
  spring, SpringUtils,
  createAnimatedComponent,
  Easing,
  Clock,
  Value,
  debug,
  block,
  cond,
  eq,
  neq,
  greaterOrEq,
  greaterThan,
  lessThan,
  multiply,
  set,
  add,
  sub,
  and,
  or,
  not,
  useCode,
  startClock,
  clockRunning,
  stopClock,
  timing as reTiming,
  proc,
  interpolate,
  Extrapolate,
  event,
  decay,
  call,
  defined,
  Transition, Transitioning, lessOrEq,
} from "react-native-reanimated";
import {
  loop,
  useValue,
  useClock,
  onGestureEvent,
  vec,
  useVector,
  pinchBegan,
  pinchActive,
  usePanGestureHandler, withDecay, withOffset, diffClamp
} from "react-native-redash/lib/module/v1";
//import { useWindowDimensions } from '../components/Utility';
import { Img } from '../components/Img';
import { Opis } from '../components/Opis';
//import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { PanGestureHandler, State, PinchGestureHandler } from 'react-native-gesture-handler';
import { useHeaderHeight } from '@react-navigation/stack'
import { useFocusEffect } from '@react-navigation/native';
import { domki } from './Domki';
import { PREFIX } from "./stylesDomki";
//import { ArrowRight, ArrowLeft } from './Arrows';
import { O } from '../components/Obrazy';
//import * as Obrazy from '../components/Obrazy';

const styles = StyleSheet.create({
  container: {
    backgroundColor: "white",
    flex: 1, // wazne, bo usuniete domyslnie z Kratka.js
    overflow: "hidden" // bez scrollbara
  },
});

const gry_focus = 7;
/*
if (
  Platform.OS === "android" &&
  UIManager.setLayoutAnimationEnabledExperimental
) {
  UIManager.setLayoutAnimationEnabledExperimental(true);
}
*/
// całkowity czas trwania animacji
const totalDuration = domki.length * 2 * 400;
// krok, po którym rozpoczyna się animowanie kolejnej zmiennej
const step = 1 / (domki.length * 2);
/*
const fadeout = ({index, clock, duration, from, easing}) => {
  const state = {
    finished: new Value(0),
    position: new Value(0),
    time: new Value(0),
    frameTime: new Value(0),
  };

  const config = {
    toValue: new Value(0),
    duration,
    easing,
  };

  return block([
    // init
    //cond(defined(from),[
    cond(and(not(clockRunning(clock)), not(state.finished)), [
      set(state.frameTime, 0),
      set(state.time, 0),
      //debug("fi", new Value(index)),
      //debug("fadeout from: ", set(state.position, from)),
      startClock(clock)
    ]),
    reTiming(clock, state, config),
    cond(state.finished, stopClock(clock)),
    state.position
    //],0)
  ]);
};
*/
const animate = ({
  fn,
  clock,
  state,
  config,
  from,
  direction
}) =>
  block([
    // init
    cond(not(clockRunning(clock)), [
      set(state.finished, 0),
      set(state.frameTime, 0),
      set(state.time, 0),
      set(state.position, from),
    ]),
    fn(clock, state, config),
    // jeśli koniec, odwróć kierunek animacji
    cond(state.finished, set(direction, not(direction))),
    // jeśli koniec animacji powrotnej, zakończ
    cond(and(state.finished, eq(direction, 0)), stopClock(clock)),
    // jeśli koniec animacji pierwszej, zainicjuj drugą
    cond(and(state.finished, eq(direction, 1)), [
      set(state.finished, 0),
      set(state.frameTime, 0),
      set(state.time, 0),
      set(config.toValue, from),
    ]),
    state.position,
  ]);

const timing = (params) => {
  const { index, val, clock, easing, duration, from, to } = {
    clock: new Clock(),
    easing: Easing.linear,
    duration: 250,
    from: 0,
    to: 1,
    ...params,
  };
  const direction = new Value(0);

  const state = {
    finished: new Value(0),
    position: new Value(0),
    time: new Value(0),
    frameTime: new Value(0),
  };

  const config = {
    toValue: new Value(0),
    duration,
    easing,
  };

  return block([
    cond(not(clockRunning(clock)), [
      // init
      set(config.toValue, to),
      set(state.frameTime, 0),
      set(state.time, 0),
      set(state.position, from),
      // start
      cond(and(not(state.finished), greaterOrEq(val, multiply(index, step))), startClock(clock)),
      // reset
      cond(and(state.finished, or(eq(val, 0), lessThan(val, multiply(index, step)))), [
        set(state.finished, 0),
        set(direction, 0),
        set(state.time, 0),
        set(state.frameTime, 0),
        set(state.position, from)
      ]),
    ],
      [
        animate({
          clock,
          fn: reTiming,
          state,
          config,
          from,
          direction,
        })
      ]),
  ]);
};

const bounce = (params) => {
  const { index, val, clock, easing, duration, from, to } = {
    clock: new Clock(),
    easing: Easing.linear,
    duration: 250,
    from: 0,
    to: 1,
    ...params,
  };
  const direction = new Value(0);

  const state = {
    finished: new Value(0),
    position: new Value(0),
    time: new Value(0),
    frameTime: new Value(0),
  };

  const config = {
    toValue: new Value(0),
    duration,
    easing,
  };

  return block([
    cond(not(clockRunning(clock)), [
      // init
      set(config.toValue, to),
      set(state.frameTime, 0),
      set(state.time, 0),
      // start
      cond(not(state.finished), startClock(clock)),
      // reset
      cond(state.finished, [
        set(state.finished, 0),
        set(direction, 0),
      ]),
    ],
      [
        animate({
          clock,
          fn: reTiming,
          state,
          config,
          from,
          direction,
        })
      ]),
  ]);
};

/*
function withManOffset(value, offset) {
  return cond(neq(value, 0), [set(offset, add(offset, value)), set(value, 0), offset], offset);
}
*/

const withManTimingOffset = (value, offset, duration, easing) => {
  const clock = new Clock();
  const state = {
    finished: new Value(0),
    position: new Value(0),
    time: new Value(0),
    frameTime: new Value(0),
  };
  const config = {
    toValue: new Value(0),
    duration: duration,
    easing: easing,
  };
  return block([
    cond(and(clockRunning(clock), not(state.finished)), [set(config.toValue, add(config.toValue, value)), cond(neq(value, 0), set(value, 0))]),
    cond(and(not(clockRunning(clock)), not(state.finished)), [
      set(state.frameTime, 0),
      set(state.time, 0),
      set(state.position, offset),
      set(config.toValue, add(offset, value)),
      cond(neq(value, 0), [startClock(clock), set(value, 0)]),
    ]),
    reTiming(clock, state, config),
    cond(state.finished, [stopClock(clock), set(offset, state.position), set(state.finished, 0), set(state.frameTime, 0), set(state.time, 0)]),
    state.position,
  ]);
}

/*
function withOffset(value, state, offset) {
  return cond(eq(state, State.END), [set(offset, add(offset, value)), offset], add(offset, value));
}

const withDecay = (value, gestureState, offset, velocity, min, max) => {
  const clock = new Clock();
  const state = {
    finished: new Value(0),
    velocity,
    position: new Value(0),
    time: new Value(0),
  };
  const config = {
    //dec eleration: 0.985,
    deceleration: 0.990,
  };
  const clamp = [
    cond(greaterOrEq(state.position, max), set(state.position, max)),
    cond(lessOrEq(state.position, min), set(state.position, min)),
  ];
  const finish = [
    clamp,
    // save
    set(offset, state.position),
    // stop
    stopClock(clock),
  ];
  return block([
    // if previous gesture running = gesture interrupted with a new one
    cond(eq(gestureState, State.BEGAN), finish),
    // if no gesture running
    cond(eq(gestureState, State.END), [
      cond(and(not(clockRunning(clock)),not(state.finished)), [
        set(state.time, 0),
        startClock(clock),
      ]),
      decay(clock, state, config),
      cond(state.finished, finish)
    ],[
      set(state.finished, 0),
      set(state.position, add(offset, value)),
    ]),
    clamp,
    // return
    state.position
  ]);
}

const manualDecay = (offset, velocity) => {
  const clock = new Clock();
  const state = {
    finished: new Value(0),
    velocity,
    position: new Value(0),
    time: new Value(0),
  };
  const config = {
    //deceleration: 0.985,
    deceleration: 0.990,
  };
  const finish = [
    //clamp,
    // save
    set(offset, state.position),
    // stop
    stopClock(clock),
  ];
  return block([
    cond(and(not(state.finished), not(clockRunning(clock))), startClock(clock)),
    set(state.position, decay(clock, state, config)),
    cond(state.finished, finish)
    state.position
  ]);
};
*/

const MAPA_WIDTH = 6948;
const MAPA_HEIGHT = 1606;//1906;

const AnimatedPath = Animated.createAnimatedComponent(Path);

export default ({ navigation, route }) => {
  //automatyczne dostosowanie do zmiany rozmiarów okna
  const windim = useWindowDimensions();
  //const windim = Dimensions.get("window");
  //const insets = useSafeAreaInsets();
  const headerHeight = useHeaderHeight();
  //const stopkaHeight = 64;
  //console.log("headerHeight: ", headerHeight);

  // wymiary okna bez nagłówka
  const safeWidth = windim.width /*- insets.left - insets.right*/;
  const safeHeight = windim.height /*- insets.top - insets.bottom*/ - headerHeight/* - stopkaHeight*/;
  const iratio = MAPA_HEIGHT / MAPA_WIDTH;
  const wratio = safeHeight / safeWidth;
  const iwidth = (iratio > wratio ? safeWidth : safeHeight / iratio);
  const iheight = (iratio > wratio ? safeWidth * iratio : safeHeight);
  /*
  console.log("r Mapa");
  console.log("screen.width: " + Dimensions.get("screen").width + " screen.height: " + Dimensions.get("screen").height + " screen.scale: " + Dimensions.get("screen").scale);
  console.log("window.width: " + windim.width + " window.height: " + windim.height + " window.scale: " + windim.scale);
  console.log("pixelratio: "+ PixelRatio.get());
  console.log("w: " + safeWidth + " h: " + safeHeight);
  console.log("in.t: " + insets.top + " in.b: " + insets.bottom + " in.l: " + insets.left + " in.r: " + insets.right);
  */
  const startAnimations = useValue(0);
  const { mainAnimRunning, focusAnims, animations, clocks, fadeClocks, val, focusVal, clk, focusClk } = useMemoOne(() => ({
    mainAnimRunning: new Value(1),
    focusAnims: new Array(domki.length).fill(0).map(() => new Value(0)),
    animations: new Array(domki.length).fill(0).map(() => new Value(0)),
    clocks: new Array(domki.length).fill(0).map(() => new Clock()),
    //fadeClocks: Array(domki.length).fill(0).map(() => new Clock()),
    val: new Value(0),
    focusVal: new Value(0),
    clk: new Clock(),
    focusClk: new Clock(),
  }), [/*safeWidth, safeHeight, iwidth, iheight*/]);
  /*
    const animations = Array(numberOfFades).fill(0).map(() => new Value(0));
    //const strokeWidth = Array(numberOfFades).fill(0).map((_,i) => interpolate(animations[i], {inputRange: [0,0.5], outputRange: [0, 25], extrapolate: Extrapolate.CLAMP }));
    const clocks = Array(numberOfFades).fill(0).map(() => new Clock());
    const val = new Value(0);
    const clk = new Clock();
  */
  //useCode(() => animations.map((animation, index) => runFade(animation, index, clocks[index])), [clocks, animations]);
  //animations.map((animation, index) => opacities[index] = mix(animation, 0, 0.5));
  //console.log("totalDuration: "+totalDuration);
  //console.log("step: "+step);

  useCode(() => cond(startAnimations, [
    cond(mainAnimRunning, [
      set(val, loop({ clock: clk, duration: totalDuration, autoStart: true })),
    ], [
      set(focusVal, loop({ clock: focusClk, duration: 250, autoStart: true })),
    ]),
    animations.map((_, index) => [
      cond(focusAnims[index],
        // domek zaznaczony - animacja specjalna
        set(animations[index], bounce({ index: 0, val: focusVal, clock: clocks[index], duration: 500, from: 0, to: 1, easing: Easing.linear })),
        // domek niezaznaczony - animacja ogólna
        set(animations[index], timing({ index: index, val: val, clock: clocks[index], duration: 1200, from: 0, to: 0.75, easing: Easing.linear }))
      ),
    ]),
  ]), [/*safeWidth, safeHeight, iwidth, iheight*/]);

  /*
    // prosta interpolacja przezroczystości domków
    const anims = new Array(domki.length).fill(0).map((_, i) => cond(focusAnims[i],
      bounce({index: 0, val: focusVal, clock: clocks[i], duration: 500, from: 0, to: 1, easing: Easing.ease}),
      interpolate(val, {inputRange: [i*step, (i+1)*step, (i+2)*step, (i+3)*step], outputRange: [0, 0.75, 0.75, 0], extrapolate: Extrapolate.CLAMP})));
  */
  function setFocusAnim(j) {
    //let focused = false;
    //LayoutAnimation.configureNext(LayoutAnimation.Presets.spring);
    //console.log("setFocusAnim: ", j);
    if ( j != -2 )
    {
      urszulaAnim.setValue(1);
      setUlaVideo(false);
    }
    setOpisy(opisy => {
      let focused = false;
      let kopiaOpisy = [...opisy];
      kopiaOpisy.map((opis) => {
        // jeśli równy wbieranemu i nie jest już wybrany, to wybierz
        if (opis.id == j && (!opis.show)) {
          focusAnims[opis.id].setValue(1);
          opis.show = true;
          focused = true;
        }
        else // w przeciwnym razie wyczyść wybór
        {
          focusAnims[opis.id].setValue(0);
          opis.show = false;
        }
      });
      // zatrzymaj główną animację, jeśli wybrano domek
      //console.log("mainAnimRunning: "+(focused ? 0 : 1))
      mainAnimRunning.setValue(focused ? 0 : 1);
      return kopiaOpisy;
    });
  }

  /*
    const ref1 = useRef(null);
    const isHovered1 = useHover(ref1);
    const isFocused1 = useFocus(ref1);
    const isActive1 = useActive(ref1);
  */
  const { panMinX, panMaxX, panMinY, panMaxY } = useMemo(() => ({
    panMinX: new Value(-iwidth + safeWidth),
    panMaxX: new Value(0),
    panMinY: new Value(-iheight + safeHeight),
    panMaxY: new Value(0),
  }), [safeWidth, safeHeight, iwidth, iheight]);
  const manTransX = useValue(0);
  const manOffsetX = useValue(0);
  const panOffsetX = useValue(0);
  const panOffsetY = useValue(0);
  const { gestureHandler, translation: panTrans, velocity: panVelocity, state: panState } = usePanGestureHandler();
  const { translateX, translateY } = useMemo(() => ({
    //translateX: withDecay(panTrans.x, panState, panOffsetX, panVelocity.x, panMinX, panMaxX),
    //translateY: withDecay(panTrans.y, panState, panOffsetY, panVelocity.y, panMinY, panMaxY),
    translateX: diffClamp(add(
      // panGestureHandler
      withDecay({ value: withOffset(panTrans.x, panState, panOffsetX), velocity: panVelocity.x, state: panState }),
      // onWheel
      withManTimingOffset(manTransX, manOffsetX, 500, Easing.inOut(Easing.quad))
    ), panMinX, panMaxX),
    translateY: diffClamp(withDecay({ value: withOffset(panTrans.y, panState, panOffsetY), velocity: panVelocity.y, state: panState }), panMinY, panMaxY),
  }), [safeWidth, safeHeight, iwidth, iheight, panMinX, panMinY, panMaxX, panMaxY]);
  /*
    const valArrowLeft = cond(startAnimations, interpolate(translateX, {inputRange: [panMinX, panMaxX], outputRange: [1, 0], extrapolate: Extrapolate.CLAMP}), 0);
    const valArrowRight = cond(startAnimations, interpolate(translateX, {inputRange: [panMinX, panMaxX], outputRange: [0, 1], extrapolate: Extrapolate.CLAMP}), 0);
  
    const CANVAS = useVector(iwidth, iheight);
    const CENTER = vec.divide(CANVAS, 2);
    const pinchOrigin = useVector(0, 0);
    const pinchFocal = useVector(0, 0);
    const pinchScale = useValue(1);
    const pinchState = useValue(State.UNDETERMINED);
    const pinchPointers = useValue(0);
    const pinchTranslation = useVector(0, 0);
    const pinchHandler = onGestureEvent({
      focalX: pinchFocal.x,
      focalY: pinchFocal.y,
      scale: pinchScale,
      state: pinchState,
      numberOfPointers: pinchPointers,
    });
    const adjustedFocal = vec.sub(pinchFocal, CENTER);
    useCode(() => [
      cond(pinchBegan(pinchState), [
        vec.set(pinchOrigin, adjustedFocal),
      ]),
      cond(pinchActive(pinchState, pinchPointers), [
        vec.set(pinchTranslation, vec.sub(adjustedFocal, pinchOrigin)),
      ],
    []),
  / *
      cond(pinchActive(pinchState, pinchPointers), [
        vec.set(pinchTranslation, vec.sub(vec.sub(pinchFocal, CENTER), pinchOrigin)),
        set(pinchFinalTranslationX, multiply(pinchTranslation.x, pinchScale)),
        set(pinchFinalTranslationY, multiply(pinchTranslation.y, pinchScale)),
      ]),
  * /
    ]);
  */
  const [opisy, setOpisy] = useState(new Array(domki.length).fill(0).map((_, i) => ({ id: i, show: false, dummy: i != gry_focus ? false : true })));
  const [ulaVideo, setUlaVideo] = useState(false);
  //const opacity = React.useMemo(() => new RNAnimated.Value(0), []);
  const opacity = new RNAnimated.Value(0);
  const videoRef = useRef(null);

  useEffect(() => {
    setFocusAnim(-2); // schowaj dymek opisu
    startAnimations.setValue(ulaVideo ? 0 : 1);
  }, [ ulaVideo ]);

  useEffect(() => {
    //console.log("mount");
    (async ()=>{
      await Audio.setAudioModeAsync({
        allowsRecordingIOS: false,
        staysActiveInBackground: false,
        interruptionModeIOS: Audio.INTERRUPTION_MODE_IOS_DO_NOT_MIX,
        playsInSilentModeIOS: true,
        shouldDuckAndroid: true,
        interruptionModeAndroid: Audio.INTERRUPTION_MODE_ANDROID_DO_NOT_MIX,
        playThroughEarpieceAndroid: false
    });  
    })();
  }, []);

  useEffect(() => async () => {
    startAnimations.setValue(0);
    if (videoRef.current != null)
      await videoRef.current.stopAsync();
    /*
    if ( videoRef.current != null )
      await videoRef.current.unloadAsync();
    */
  }, []);

  // zatrzymaj wideo, gdy nawiguje do innego ekranu
  useFocusEffect(
    React.useCallback(() => {
      // Do something when the screen is focused
      startAnimations.setValue(1);
      return async () => {
        // Do something when the screen is unfocused
        // Useful for cleanup functions
        startAnimations.setValue(0);
        if (videoRef.current != null)
          await videoRef.current.stopAsync();
        /*
        if ( videoRef.current != null )
          await videoRef.current.unloadAsync();
        */
      };
    }, [])
  );

  const urszulaClock = useClock();
  const urszulaAnim = useValue(0);
  const urszulaTop = useValue(0);
  const urszulaValue = useValue(0);
  const configSpring = SpringUtils.makeConfigFromOrigamiTensionAndFriction({
    ...SpringUtils.makeDefaultConfig(),
    friction: 100,
    tension: 1000,
    stiffness: 100,
    mass: 10,
    overshootClamping: true,
    restDisplacementThreshold: 5,
    restSpeedThreshold: 5,
  });
  const state = {
    finished: new Value(1),
    position: new Value(0),
    time: new Value(0),
    velocity: new Value(0),
  };

  useCode(() => [
    cond(eq(urszulaAnim, 1), [
      cond(state.finished, [
        set(state.finished, 0),
        set(state.position, urszulaValue),
        set(configSpring.toValue, cond(eq(configSpring.toValue, -30), 0, -30)),
        startClock(urszulaClock),
      ]),
      spring(urszulaClock, state, configSpring),
      cond(state.finished, [set(urszulaValue, state.position), cond(eq(configSpring.toValue, 0), set(urszulaAnim, 0))]),
      set(urszulaTop, state.position),
    ])
  ], [urszulaAnim]);

  return (
    <View style={styles.container}>
    <Kratka>
      {/*
    <PinchGestureHandler {...pinchHandler}>
      <Animated.View style={{...StyleSheet.absoluteFill, width: iwidth, height: iheight,
          transform: [
            {
              translateX: pinchOrigin.x,
              translateY: pinchOrigin.y,
              scale: pinchScale 
            },
            {
              translateX: multiply(-1, pinchOrigin.x),
              translateY: multiply(-1, pinchOrigin.y),
            },
          ]
        }}>
*/}
      <PanGestureHandler {...gestureHandler}>
        <Animated.View
          renderToHardwareTextureAndroid
          onMouseMove={() => { urszulaAnim.setValue(1) }}
          onKeyDown={(e) => {
            if (e.key === "ArrowRight" || e.key === "ArrowDown")
              manTransX.setValue(-100);
            if (e.key === "ArrowLeft" || e.key === "ArrowUp")
              manTransX.setValue(100);
            if (e.key === "PageDown" || e.key === "End")
              manTransX.setValue(-iwidth);
            if (e.key === "PageUp" || e.key === "Home")
              manTransX.setValue(iwidth);
          }}
          onWheel={(e) => { manTransX.setValue(- e.deltaX / 10 - e.deltaY); }}
          style={[/*styles.container, */{ width: iwidth, height: iheight, transform: [{ translateX }, { translateY }] }]}>

            <Image source={O.Sanktuarium.Napis1} style={{ position: 'absolute', top: iheight / 20, left: iwidth / 10, width: iheight / 5 * 2001 / 307, height: iheight / 5 }} />
            <Image source={O.Sanktuarium.Legenda} style={{ position: 'absolute', top: iheight / 20, left: iwidth / 10 * 4.2, width: iheight / 3 * 517 / 582, height: iheight / 3 }} />
            <Image source={O.Sanktuarium.Napis2} style={{ position: 'absolute', top: iheight / 20, left: iwidth / 10 * 6, width: iheight / 5 * 1482 / 294, height: iheight / 5 }} />
            <Image onLoad={() => { startAnimations.setValue(1) }} source={O.Sanktuarium.Mapa} style={{ ...StyleSheet.absoluteFillObject, width: iwidth, height: iheight }} />
            {/*
      <Img onLoad={()=>{startAnimations.setValue(1)}} source={O.Sanktuarium.Mapa} preview={O.Sanktuarium.Mapa} style={{...StyleSheet.absoluteFillObject, width: iwidth, height: iheight }} />
      <Img onLoad={()=>{startAnimations.setValue(1)}} source={{ uri: PREFIX + "piecpiaty.pl/assets/mapa.png", width: MAPA_WIDTH, height: MAPA_HEIGHT }} preview={O.Sanktuarium.MapaPreview} style={{...StyleSheet.absoluteFillObject, width: iwidth, height: iheight }} />
      {domki.map((domek, i) => 
      ( ! domek.dummy ) && <Animated.Image
        key={'ai'+i}
        source={domek.image}
        style={{...StyleSheet.absoluteFillObject, width: iwidth, height: iheight, opacity: animations[i]}}
        />
      )}
*/}

            {Platform.OS === "web" && domki.map((domek, i) =>
              (!domek.dummy) && <Animated.View key={"avsvg" + i} style={{ opacity: animations[i], ...StyleSheet.absoluteFillObject, width: iwidth, height: iheight }}>
                <Svg viewBox={"0 0 " + MAPA_WIDTH + " " + MAPA_HEIGHT} style={{ ...StyleSheet.absoluteFillObject, width: iwidth, height: iheight }}>
                  {domek.ds.map((d, j) =>
                    <Path key={"avsvg" + i + "d" + j} stroke="yellow" strokeWidth="10" fill="none" /*fill="yellow" fillOpacity="0.4"*/ d={d} />
                  )}
                </Svg>
              </Animated.View>
            )}

            {Platform.OS === "web" && <Animated.View style={{ opacity: animations[gry_focus], ...StyleSheet.absoluteFillObject, width: iwidth, height: iheight }}>
              <Svg viewBox={"0 0 " + MAPA_WIDTH + " " + MAPA_HEIGHT} style={{ ...StyleSheet.absoluteFillObject, width: iwidth, height: iheight }}>
                <Path stroke="yellow" strokeWidth="10" fill="none" /*fill="yellow" fillOpacity="0.4"*/ d="M 6330 1315 a 161 161 90 0 0 52 -7 v -1 c -16 -20 -22 -110 -30 -144 h -4 c -20 6 -54 17 -74 13 l -3 -19 l -2 1 l -63 85 l 1 2 c 67 10 64 33 88 83 c 6 12 24 34 20 51 c -4 19 -37 49 -49 64 c -8 11 -30 46 -43 49 c -18 4 -82 -20 -99 -25 c -11 -3 -25 -3 -31 -11 l -31 -65 l -34 -25 l -73 -54 c -8 -6 -14 -14 -24 -17 c -12 73 -26 64 -93 79 c -14 3 -36 14 -54 9 c -13 -3 -89 -69 -96 -80 c -11 -16 17 -92 23 -112 c 3 -11 4 -30 12 -36 s 25 -7 38 -9 l -8 -64 h -1 c -59 32 -132 84 -173 135 c -14 18 -38 37 -44 62 c -4 18 40 71 49 83 c 50 64 143 131 255 131 c -2 -15 1 -20 8 -28 l 4 2 c 2 6 4 6 5 11 c 20 -11 61 -19 91 -13 l 4 5 l -2 16 c -12 17 -53 16 -81 16 c 2 5 2 2 5 4 l -9 12 l -7 1 c -12 -5 -14 -11 -18 -23 c -107 -1 -204 -63 -252 -124 c -19 -24 -45 -50 -54 -83 l -2 1 c -2 13 -8 31 -7 43 c 6 71 40 105 99 123 c 35 11 56 14 79 35 l 3 -3 l -2 -1 c 2 -14 29 -15 30 0 a 35 35 90 0 1 -15 14 v 1 l 15 1 l -5 -2 l 2 -3 h 1 c 23 1 82 39 63 64 c -21 6 -79 -36 -90 -49 c 3 -3 4 -1 6 -6 c -6 3 -12 8 -20 6 v -1 a 59 59 90 0 1 10 -18 c -14 -15 -39 -25 -62 -31 c -7 -2 -17 0 -21 -2 v -4 c -61 -10 -89 -56 -99 -119 c -4 -25 14 -41 11 -59 l -15 -48 l -8 -62 c -6 -38 6 -78 15 -107 c 28 -90 94 -166 212 -152 l -6 -53 l 86 -11 l 4 -45 l 109 7 l 13 -39 l 57 17 l 140 43 c 21 6 72 15 86 27 c -4 21 -34 103 -28 117 l 22 17 l 76 58 c 10 8 31 16 36 28 l -3 6 l 6 -2 c -4 -11 -7 -58 -10 -62 c -5 -5 -32 -7 -42 -21 c -25 -34 -4 -81 22 -97 c 10 -6 22 -6 39 -10 c 13 -3 35 -10 53 -4 c 39 13 45 67 22 101 h 5 l 12 68 h 4 c 11 -4 92 -21 100 -12 c 6 5 15 63 12 74 c -28 3 -56 13 -82 18 v 1 c 9 -1 18 -4 25 -1 c 5 10 16 76 15 78 l -39 9 l 39 -6 c 5 2 17 62 17 68 c 23 -2 52 -9 73 -4 c 1 17 13 77 4 85 l -38 4 v 1 c 5 25 21 49 20 73 c -50 8 -98 28 -150 33 c 0 -4 -1 -5 0 -9 l 4 -1 c -9 -19 -12 -45 -19 -66 a 248 248 90 0 1 -66 13 c -1 5 -1 5 -9 4 C 6334 1383 6328 1349 6330 1315 Z" />
              </Svg>
            </Animated.View>}

            <Svg viewBox={"0 0 " + MAPA_WIDTH + " " + MAPA_HEIGHT} style={{ ...StyleSheet.absoluteFillObject, width: iwidth, height: iheight }}>
              <Defs>
                <ClipPath id={"c" + gry_focus}>
                  <Path d="M 6330 1315 a 161 161 90 0 0 52 -7 v -1 c -16 -20 -22 -110 -30 -144 h -4 c -20 6 -54 17 -74 13 l -3 -19 l -2 1 l -63 85 l 1 2 c 67 10 64 33 88 83 c 6 12 24 34 20 51 c -4 19 -37 49 -49 64 c -8 11 -30 46 -43 49 c -18 4 -82 -20 -99 -25 c -11 -3 -25 -3 -31 -11 l -31 -65 l -34 -25 l -73 -54 c -8 -6 -14 -14 -24 -17 c -12 73 -26 64 -93 79 c -14 3 -36 14 -54 9 c -13 -3 -89 -69 -96 -80 c -11 -16 17 -92 23 -112 c 3 -11 4 -30 12 -36 s 25 -7 38 -9 l -8 -64 h -1 c -59 32 -132 84 -173 135 c -14 18 -38 37 -44 62 c -4 18 40 71 49 83 c 50 64 143 131 255 131 c -2 -15 1 -20 8 -28 l 4 2 c 2 6 4 6 5 11 c 20 -11 61 -19 91 -13 l 4 5 l -2 16 c -12 17 -53 16 -81 16 c 2 5 2 2 5 4 l -9 12 l -7 1 c -12 -5 -14 -11 -18 -23 c -107 -1 -204 -63 -252 -124 c -19 -24 -45 -50 -54 -83 l -2 1 c -2 13 -8 31 -7 43 c 6 71 40 105 99 123 c 35 11 56 14 79 35 l 3 -3 l -2 -1 c 2 -14 29 -15 30 0 a 35 35 90 0 1 -15 14 v 1 l 15 1 l -5 -2 l 2 -3 h 1 c 23 1 82 39 63 64 c -21 6 -79 -36 -90 -49 c 3 -3 4 -1 6 -6 c -6 3 -12 8 -20 6 v -1 a 59 59 90 0 1 10 -18 c -14 -15 -39 -25 -62 -31 c -7 -2 -17 0 -21 -2 v -4 c -61 -10 -89 -56 -99 -119 c -4 -25 14 -41 11 -59 l -15 -48 l -8 -62 c -6 -38 6 -78 15 -107 c 28 -90 94 -166 212 -152 l -6 -53 l 86 -11 l 4 -45 l 109 7 l 13 -39 l 57 17 l 140 43 c 21 6 72 15 86 27 c -4 21 -34 103 -28 117 l 22 17 l 76 58 c 10 8 31 16 36 28 l -3 6 l 6 -2 c -4 -11 -7 -58 -10 -62 c -5 -5 -32 -7 -42 -21 c -25 -34 -4 -81 22 -97 c 10 -6 22 -6 39 -10 c 13 -3 35 -10 53 -4 c 39 13 45 67 22 101 h 5 l 12 68 h 4 c 11 -4 92 -21 100 -12 c 6 5 15 63 12 74 c -28 3 -56 13 -82 18 v 1 c 9 -1 18 -4 25 -1 c 5 10 16 76 15 78 l -39 9 l 39 -6 c 5 2 17 62 17 68 c 23 -2 52 -9 73 -4 c 1 17 13 77 4 85 l -38 4 v 1 c 5 25 21 49 20 73 c -50 8 -98 28 -150 33 c 0 -4 -1 -5 0 -9 l 4 -1 c -9 -19 -12 -45 -19 -66 a 248 248 90 0 1 -66 13 c -1 5 -1 5 -9 4 C 6334 1383 6328 1349 6330 1315 Z" />
                </ClipPath>
                {Platform.OS !== "ios" && domki.map((domek, i) =>
                  (!domek.dummy) && <ClipPath id={"c" + i} key={"cp" + i}>
                    {domek.ds.map((d, j) =>
                      <Path key={"cp" + i + "d" + j} d={d} />
                    )}
                  </ClipPath>
                )}
                {Platform.OS === "ios" && domki.map((domek, i) =>
                  (!domek.dummy) && domek.ds.map((d, j) =>
                    <ClipPath id={"c" + i + "_" + j} key={"cp" + i + "_" + j}>
                      <Path key={"cp" + i + "d" + j} d={d} />
                    </ClipPath>
                  ))}
              </Defs>

              {Platform.OS !== 'web' && (
                domki.map((domek, i) =>
                  (!domek.dummy) &&
                  domek.ds.map((d, j) =>
                    <AnimatedPath key={"ap" + i + "d" + j} style={{ opacity: animations[i] }} stroke="yellow" strokeWidth={10} fill="none"/* fill="yellow" fillOpacity={0.4}*/ d={d} />
                  )
                )
              )}

              {Platform.OS !== 'web' &&
                <AnimatedPath style={{ opacity: animations[gry_focus] }} stroke="yellow" strokeWidth="10" fill="none"/* fill="yellow" fillOpacity="0.4"*/ d="M 6330 1315 a 161 161 90 0 0 52 -7 v -1 c -16 -20 -22 -110 -30 -144 h -4 c -20 6 -54 17 -74 13 l -3 -19 l -2 1 l -63 85 l 1 2 c 67 10 64 33 88 83 c 6 12 24 34 20 51 c -4 19 -37 49 -49 64 c -8 11 -30 46 -43 49 c -18 4 -82 -20 -99 -25 c -11 -3 -25 -3 -31 -11 l -31 -65 l -34 -25 l -73 -54 c -8 -6 -14 -14 -24 -17 c -12 73 -26 64 -93 79 c -14 3 -36 14 -54 9 c -13 -3 -89 -69 -96 -80 c -11 -16 17 -92 23 -112 c 3 -11 4 -30 12 -36 s 25 -7 38 -9 l -8 -64 h -1 c -59 32 -132 84 -173 135 c -14 18 -38 37 -44 62 c -4 18 40 71 49 83 c 50 64 143 131 255 131 c -2 -15 1 -20 8 -28 l 4 2 c 2 6 4 6 5 11 c 20 -11 61 -19 91 -13 l 4 5 l -2 16 c -12 17 -53 16 -81 16 c 2 5 2 2 5 4 l -9 12 l -7 1 c -12 -5 -14 -11 -18 -23 c -107 -1 -204 -63 -252 -124 c -19 -24 -45 -50 -54 -83 l -2 1 c -2 13 -8 31 -7 43 c 6 71 40 105 99 123 c 35 11 56 14 79 35 l 3 -3 l -2 -1 c 2 -14 29 -15 30 0 a 35 35 90 0 1 -15 14 v 1 l 15 1 l -5 -2 l 2 -3 h 1 c 23 1 82 39 63 64 c -21 6 -79 -36 -90 -49 c 3 -3 4 -1 6 -6 c -6 3 -12 8 -20 6 v -1 a 59 59 90 0 1 10 -18 c -14 -15 -39 -25 -62 -31 c -7 -2 -17 0 -21 -2 v -4 c -61 -10 -89 -56 -99 -119 c -4 -25 14 -41 11 -59 l -15 -48 l -8 -62 c -6 -38 6 -78 15 -107 c 28 -90 94 -166 212 -152 l -6 -53 l 86 -11 l 4 -45 l 109 7 l 13 -39 l 57 17 l 140 43 c 21 6 72 15 86 27 c -4 21 -34 103 -28 117 l 22 17 l 76 58 c 10 8 31 16 36 28 l -3 6 l 6 -2 c -4 -11 -7 -58 -10 -62 c -5 -5 -32 -7 -42 -21 c -25 -34 -4 -81 22 -97 c 10 -6 22 -6 39 -10 c 13 -3 35 -10 53 -4 c 39 13 45 67 22 101 h 5 l 12 68 h 4 c 11 -4 92 -21 100 -12 c 6 5 15 63 12 74 c -28 3 -56 13 -82 18 v 1 c 9 -1 18 -4 25 -1 c 5 10 16 76 15 78 l -39 9 l 39 -6 c 5 2 17 62 17 68 c 23 -2 52 -9 73 -4 c 1 17 13 77 4 85 l -38 4 v 1 c 5 25 21 49 20 73 c -50 8 -98 28 -150 33 c 0 -4 -1 -5 0 -9 l 4 -1 c -9 -19 -12 -45 -19 -66 a 248 248 90 0 1 -66 13 c -1 5 -1 5 -9 4 C 6334 1383 6328 1349 6330 1315 Z" />
              }

              {Platform.OS === 'web' && <Rect
                x="0" y="0" width="100%" height="100%"
                fill="rgb(28,188,180)" fillOpacity="0" opacity="0"
                onPress={() => {
                  // odznacz wszystkie
                  setFocusAnim(-1);
                }}
              />}
              {Platform.OS === 'android' && <Rect
                x="0" y="0" width="100%" height="100%"
                fill="none" /*fill="rgb(28,188,180)" fillOpacity="0"*/ opacity="0"
                onPress={() => {
                  // odznacz wszystkie
                  setFocusAnim(-1);
                }}
              />}
              {Platform.OS === 'ios' && <Rect
                x="0" y="0" width="100%" height="100%"
                fill="rgb(28,188,180)" fillOpacity="0" opacity="1"
                onPress={() => {
                  // odznacz wszystkie
                  setFocusAnim(-1);
                }}
              />}

              {Platform.OS === 'web' && <Rect
                clipPath={'url(#c' + gry_focus + ')'}
                x="0" y="0" width="100%" height="100%"
                fill="rgb(28,188,180)" fillOpacity="0" opacity="0"
                onPress={() => {
                  // zaznacz i
                  setFocusAnim(gry_focus);
                }}
                onLongPress={() => navigation.navigate("Gry")}
                onDoubleClick={() => navigation.navigate("Gry")}
                style={{ cursor: 'pointer' }}
              />}
              {Platform.OS === 'android' && <Rect
                clipPath={'url(#c' + gry_focus + ')'}
                x="0" y="0" width="100%" height="100%"
                fill="none" /*fill="rgb(28,188,180)" fillOpacity="0"*/ opacity="0"
                onPress={() => {
                  // zaznacz i
                  setFocusAnim(gry_focus);
                }}
                onLongPress={() => navigation.navigate("Gry")}
              />}
              {Platform.OS === 'ios' &&
                <Rect pointerEvents="box-none"
                  clipPath={'url(#c' + gry_focus + ')'}
                  x="0" y="0" width="100%" height="100%"
                  fill="rgb(28,188,180)" fillOpacity="0" opacity="1"
                  onPress={() => {
                    // zaznacz i
                    setFocusAnim(gry_focus);
                  }}
                  onLongPress={() => navigation.navigate("Gry")}
                />
              }

              {Platform.OS === 'web' && domki.map((domek, i) =>
                (!domek.dummy) && <Rect
                  key={'svgi' + i}
                  clipPath={'url(#c' + i + ')'}
                  x="0" y="0" width="100%" height="100%"
                  fill="rgb(28,188,180)" fillOpacity="0" opacity="0"
                  onPress={() => {
                    // zaznacz i
                    setFocusAnim(i);
                  }}
                  onLongPress={() => {
                    navigation.navigate(domek.name, { domek });
                  }}
                  onDoubleClick={() => {
                    navigation.navigate(domek.name, { domek });
                  }}
                  style={{ cursor: 'pointer' }}
                />
              )}
              {Platform.OS === 'android' && domki.map((domek, i) =>
                (!domek.dummy) && <Rect
                  key={'svgi' + i}
                  clipPath={'url(#c' + i + ')'}
                  x="0" y="0" width="100%" height="100%"
                  fill="none" /*fill="rgb(28,188,180)" fillOpacity="0"*/ opacity="0"
                  onPress={() => {
                    // zaznacz i
                    setFocusAnim(i);
                  }}
                  onLongPress={() => {
                    navigation.navigate(domek.name, { domek });
                  }}
                />
              )}
              {Platform.OS === 'ios' && domki.map((domek, i) =>
                (!domek.dummy) && domek.ds.map((d, j) =>
                  <Rect pointerEvents="box-none"
                    key={'svgi' + i + '_' + j}
                    clipPath={'url(#c' + i + '_' + j + ')'}
                    x="0" y="0" width="100%" height="100%"
                    fill="rgb(28,188,180)" fillOpacity="0" opacity="1"
                    onPress={() => {
                      // zaznacz i
                      setFocusAnim(i);
                    }}
                    onLongPress={() => {
                      //mainAnimRunning.setValue(0);
                      navigation.navigate(domek.name, { domek });
                    }}
                  />
                ))}

            </Svg>
            <Image source={O.Sanktuarium.PionekMapa} style={{ position: 'absolute', top: iheight / 20, left: iwidth / 10 * 5.2, width: iheight / 2.5 * 256 / 560, height: iheight / 2.5 }} />
            <TouchableOpacity onPress={() => setUlaVideo(true)} style={{ position: 'absolute', top: iheight / 20, left: iwidth / 10 * 5.6, width: iheight / 2.5 * 258 / 560, height: iheight / 2.5 }}>
              <Animated.Image source={O.Sanktuarium.Pionek} style={{ width: iheight / 2.5 * 258 / 560, height: iheight / 2.5, top: urszulaTop }} />
            </TouchableOpacity>

        </Animated.View>
      </PanGestureHandler>
      {/*
      <ArrowLeft opacity={valArrowLeft} width={Math.floor((iheight/15)*PixelRatio.get())} height={(Math.floor(iheight/30)*PixelRatio.get())} viewBox={"0 0 270 50"} style={{...StyleSheet.absoluteFillObject, top: safeHeight - Math.floor(iheight/30*PixelRatio.get()) - 30, left: 30}} />
      <ArrowRight opacity={valArrowRight} width={Math.floor((iheight/15)*PixelRatio.get())} height={(Math.floor(iheight/30)*PixelRatio.get())} viewBox={"0 0 270 50"} style={{...StyleSheet.absoluteFillObject, top: safeHeight - Math.floor(iheight/30*PixelRatio.get()) - 30, left: safeWidth - Math.floor(iheight/15*PixelRatio.get())-30}} />
      */}
      {opisy.map((opis, i) =>
        (!opis.dummy) && <Opis show={opis.show} key={'opis' + i} style={{
          position: 'absolute',
          width: safeWidth / 3,
          top: 10,
          left: (domki[i].pos === "left") ? 10 : safeWidth - 750 / PixelRatio.get() - 10,
          /*...Platform.select({ web: { height: 0 }}),*/
        }} title={domki[i].title} opis={domki[i].opis} safeWidth={safeWidth} safeHeight={safeHeight} />
      )}
      {/*
      </Animated.View>
      </PinchGestureHandler>
*/}
      { Platform.OS === 'web' && ulaVideo &&
        <RNAnimated.View onContextMenu={(e) => { e.preventDefault(); }} style={{ opacity: opacity, alignSelf: 'center', ...StyleSheet.absoluteFillObject, height: safeHeight * 0.8, width: safeHeight * 0.8 * 1920 / 1080, top: (safeHeight - safeHeight * 0.8) / 2, left: (safeWidth - safeHeight * 0.8 * 1920 / 1080) / 2 }}>
          <Video
            ref={videoRef}
            source={{ uri: PREFIX + "piecpiaty.pl/assets/Ula.mp4", width: 1920, height: 1080 }}
            onLoad={() => {
              document.querySelector("video").controlsList = "nodownload";
              RNAnimated.timing(opacity, {
                toValue: 1,
                ...Platform.select({ "native": { useNativeDriver: true } }),
              }).start((finished) => {
                if (finished && videoRef.current != null)
                  videoRef.current.presentFullscreenPlayer();
              });
            }}
            rate={1.0}
            volume={1.0}
            isMuted={false}
            resizeMode="contain"
            shouldPlay
            useNativeControls
            style={{ height: safeHeight * 0.8, width: safeHeight * 0.8 * 1920 / 1080 }}
          />
        </RNAnimated.View>}
      { Platform.OS !== 'web' && ulaVideo &&
        <RNAnimated.View renderToHardwareTextureAndroid style={{ opacity: opacity, alignSelf: 'center', ...StyleSheet.absoluteFillObject, height: safeHeight * 0.8, width: safeHeight * 0.8 * 1280 / 720, top: (safeHeight - safeHeight * 0.8) / 2, left: (safeWidth - safeHeight * 0.8 * 1280 / 720) / 2 }}>
          <Video
            ref={videoRef}
            source={{ uri: PREFIX + "piecpiaty.pl/assets/Ulam.mp4", width: 1280, height: 720 }}
            onLoad={() => {
              RNAnimated.timing(opacity, {
                toValue: 1,
                ...Platform.select({ "native": { useNativeDriver: true } }),
              }).start((finished) => {
                if (finished && videoRef.current != null) {
                  videoRef.current.presentFullscreenPlayer();
                }
              });
            }}
            rate={1.0}
            volume={1.0}
            isMuted={false}
            resizeMode="contain"
            shouldPlay
            useNativeControls
            style={{ height: safeHeight * 0.8, width: safeHeight * 0.8 * 1280 / 720 }}
          />
        </RNAnimated.View>}
      </Kratka>
    </View>
  );
};
